import { render, staticRenderFns } from "./UploadIDPhoto.vue?vue&type=template&id=68871bc3&scoped=true&"
import script from "./UploadIDPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadIDPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadIDPhoto.vue?vue&type=style&index=0&id=68871bc3&lang=less&scoped=true&"
import style1 from "./UploadIDPhoto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68871bc3",
  null
  
)

export default component.exports